<link rel="stylesheet" type="text/css" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css">
<link rel="stylesheet" type="text/css"
  href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.3.0/font/bootstrap-icons.css">

<ion-content scrollY="false">
  <div class="inspection-main">
    <!-- HEADER + LOCATION-->
    <div class="inspection-header" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- LEFT: TITLE -->
      <h2 class="inspection-title">
        {{ 'native_text.inspection_card_text' | translate }}
      </h2>

      <!-- RIGHT: LOCATION -->
      <div class="location-box" fxLayout="row" fxLayoutAlign="center center" (click)="_appServices.openModel(1,address)"
        *ngIf="isAddressVerificationEnabled && isLocationAllowed">
        <ion-icon name="location-outline"></ion-icon>
        <!-- Truncated Address -->
        <span class="location-text">
          {{ address?.length > 15 ? (address | slice:0:15) + '...' : address }}
        </span>

        <ion-icon name="caret-down-outline"></ion-icon>
      </div>

    </div>
    <!-- TABS -->
    <div class="inspection-cards-container">

      <swiper-container #ZoneCardsSlider [options]="slideOpts" class="tab-slides"
        (ionSlideReachStart)="onSlideReachStart()" (ionSlideReachEnd)="onSlideReachEnd()">
        <!-- <swiper-slide *ngFor="let zone of _tempDynamicFormConfig.serverData; let j = index" class="slide-design">
          <div class="tab" [class.active]="j === selectedTabIndex" (click)="onTabClick(j)">
            {{ getZoneName(zone.templateId) }}
            <span *ngIf="j === selectedTabIndex  && _tempDynamicFormConfig?.highlightcontrols">
              <ion-icon *ngIf="mediaHasError || quesHasError" name="alert-circle-outline" class="error-icon-tabs">
              </ion-icon>
              <ion-icon *ngIf="showZoneSuccessIcon && !mediaHasError && !quesHasError" name="checkmark-circle-outline"
                class="success-icon">
              </ion-icon>
            </span>
          </div>
        </swiper-slide> -->
        <swiper-slide *ngFor="let zone of _tempDynamicFormConfig.serverData; let j = index" class="slide-design">
          <div class="tab" [class.active]="j === selectedTabIndex" (click)="onTabClick(j)">
            <span [class.blink-mandatory]="
        _tempDynamicFormConfig?.highlightcontrols &&
        j !== selectedTabIndex &&
        zoneValidationMap.get(zone.templateId)">
              {{ getZoneName(zone.templateId) }}
            </span>
          </div>
        </swiper-slide>
        <swiper-slide class="slide-design add-zone-slide" *ngIf="listForAddNewZone?.length > 0 && isAddZoneEnable">
          <div class="tab add-zone-tab" [class.disabled-slide]="disableaddZone" (click)="OpenAddZoneControl()">
            + {{'self_pwa_text.add_zones' | translate}}
          </div>
        </swiper-slide>

      </swiper-container>

    </div>
  </div>
  <!-- Location Section -->
  <div fxLayout="column" fxLayoutAlign="start start" style="height: 100%;overflow-y: auto;">
    <mat-accordion class="dynamic-card-accordian">
      <!-- Accordion Panel for Plumbing -->
      <mat-expansion-panel class="expensionPanel" [expanded]="true" [hideToggle]="true" [disabled]="true">

        <div fxLayout="column" fxLayoutAlign="start stretch" class="background-white p-b-10">
          <ion-segment *ngIf="segments.length" [(ngModel)]="selectedTab" class="custom-segment segmented-control"
            (ionChange)="onSegmentChange($event)" mode="ios">

            <ion-segment-button *ngFor="let segment of segments; let j = index" [value]="segment.value" class="segment">
              <ion-label>
                {{ segment.labelKey | translate }}
                <span *ngIf="segment.value === 'Media' && _tempDynamicFormConfig?.highlightcontrols">
                  <ion-icon *ngIf="mediaHasError" name="alert-circle" class="error-icon-tabs">
                  </ion-icon>
                  <ion-icon *ngIf="showSuccessIcon && !mediaHasError" name="checkmark-circle" class="success-icon">
                  </ion-icon>
                </span>

                <span *ngIf="segment.value === 'Questionnaire' && _tempDynamicFormConfig?.highlightcontrols">
                  <ion-icon *ngIf="quesHasError" name="alert-circle" class="error-icon-tabs">
                  </ion-icon>
                  <ion-icon *ngIf="showSuccessIconQues && !quesHasError" name="checkmark-circle" class="success-icon">
                  </ion-icon>
                </span>
              </ion-label>
            </ion-segment-button>

          </ion-segment>
          <div class="back-to-inspection" (click)="BackEvent()" *ngIf="parentData != null && selectedTab == 'Media'">
            <ion-icon name="arrow-back-outline"></ion-icon>
            <span>{{ 'self_pwa_text.go_back_to' | translate }} {{goBackLabel}}</span>
          </div>
          <div class="custom-zone-header" *ngIf="parentData != null && selectedTab == 'Media'">
            <div class="zone-left">
              <span><ion-icon name="return-down-forward-outline"
                  class="right-icon-style font-size-22"></ion-icon></span>
              <span class="zone-title">{{ showZoneName }}</span>
            </div>

            <!-- <button class="go-back-btn" (click)="BackEvent()">
              {{ 'portal_text.back_text' | translate }}
            </button> -->
          </div>

          <div *ngIf="selectedTab === 'Media'">
            <div fxLayout="column" class="p-0 background-white" fxLayoutAlign="start stretch">
              <div fxLayout="row" fxLayoutAlign="start center" class="m-8-15">
                <div class="options" *ngIf="_tempDynamicFormConfig?.highlightcontrols">
                  <span class="mandatory_sign">*</span>
                  <span class="color-netral-700 font-size-14 inter-regular">{{"common_text.mandetory_text" |
                    translate}}</span>
                </div>
                <div class="options" *ngIf="_tempDynamicFormConfig?.highlightcontrols">
                  <span class="options-div background-orange"></span>
                  <span class="color-netral-700 font-size-14 inter-regular">{{"common_text.recomended_text" |
                    translate}}</span>
                </div>
                <div class="options" *ngIf="repeatableControlList?.length > 0">
                  <span class="back-color font-size-14 inter-regular" style="position: absolute; right: 5%;"
                    (click)="openModal()"><u>
                      {{'self_pwa_text.add_more' | translate}}
                    </u></span>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="m-8-15"
                *ngIf="updatedFieldsforCustomForm && updatedFieldsforCustomForm[0]?.templateJson.length == 0">
                <p>{{'self_pwa_text.no_media_found' | translate}}</p>
              </div>

              <ion-card *ngFor="let formData of _tempDynamicFormConfig.tempCustomJson; trackBy: trackById"
                (click)="getEvent(formData)"
                [ngClass]="{'display-none': formData.controlType === 'form', 'border-red': isMediaError(formData), 'border-orange' : isMediaRecomended(formData),'border-red-title': getTitleValidationState(formData) === 'mandatory', 'border-orange-title': getTitleValidationState(formData) === 'recommended'}"
                [ngStyle]="{'border-radius': '10px', 'cursor': 'pointer','margin-bottom':'5px','margin-top':'5px', 'border':'2px dashed #cccccc' }"
                [hidden]="!formData.isVisible">
                <ng-container *ngIf="formData.controlType != 'title'; else showImage">
                  <ion-card-content fxLayout="row" style="display: flow;" fxLayoutAlign="space-between center"
                    fxLayoutGap="10px" [ngStyle]="{
    'padding': formData?.value?.length > 0 ? '25px 5px 10px 10px' : '0px'}">
                    <ng-container *ngIf="formData?.value?.length > 0; else noPhotos">
                      <!-- LABEL -->
                      <p class="color-netral-600 font-size-16 smaller-label">
                        {{ formData.label[_appSetting.selectedLanguage] }}
                        <span *ngIf="formData?.mandatory == 1" class="mandatory-star">*</span>
                        <span *ngIf="formData?.mandatory == 2" class="recomended-dot">●</span>
                      </p>
                      <!-- MAIN ROW -->
                      <div class="media-row">
                        <!-- LEFT GROUP (IMAGES + COUNT) -->
                        <div class="media-left">
                          <ng-container *ngFor="let img of formData?.value; let i = index">
                            <div *ngIf="i < 3 || showAllImages" class="media-box"
                              (click)="GotoGalleryImageDetails(img, formData)">
                              <img *ngIf="img.FileType === 'images'" [src]="img.localFileUrl" class="media-img" />
                              <img *ngIf="img.FileType === 'videos'" src="assets/images/videoThumbnail.png"
                                class="media-img" />
                              <img *ngIf="img.FileType === 'files'" [src]="_appServices.showFileThumbnail(img.FileName)"
                                class="media-img" />
                            </div>
                            <!-- +COUNT -->
                            <div *ngIf="i === 3 && !showAllImages" class="media-box more-count"
                              (click)="toggleShowAllImages($event)">
                              +{{ formData?.value.length - 3 }}
                            </div>
                          </ng-container>
                        </div>
                        <!-- RIGHT: ADD BUTTON -->
                        <div *ngIf="formData.multiple" class="media-box add-btn" (click)="clickMorePhoto(formData)">
                          <ion-icon name="add-outline"></ion-icon>
                        </div>
                      </div>
                    </ng-container>

                    <!-- NO PHOTOS TEMPLATE (UNCHANGED LOGIC) -->
                    <ng-template #noPhotos>
                      <ion-card-content fxLayout="row" fxLayoutAlign="space-between center">
                        <div fxLayout="row" fxLayoutAlign="start center">
                          <ion-icon [name]="formData.controlType === 'title' ? 'return-down-forward-outline' :
                  formData.controlType === 'videos' ? 'videocam-outline' :
                  formData.controlType === 'photos' ? 'image-outline' :
                  formData.controlType === 'satellite' ? 'locate-outline' :
                  'document-outline'" class="captured_icon">
                          </ion-icon>
                          <div fxLayout="column" fxLayoutAlign="center start">
                            <h3 class="color-netral-900 font-size-18 l-h-1-3"
                              [ngClass]="{'text-error': isMediaError(formData)}">
                              {{ formData.label[_appSetting.selectedLanguage] }}
                              <span *ngIf="formData?.mandatory == 1" class="mandatory-star">*</span>
                              <span *ngIf="formData?.mandatory == 2" class="recomended-dot">●</span>
                            </h3>
                            <p class="color-netral-500 font-size-14"
                              *ngIf="!isMediaError(formData) && ! isMediaRecomended(formData)">
                              {{ 'self_pwa_text.Tap_to_add_media_text' | translate }}
                            </p>
                            <p *ngIf="isMediaError(formData)" class="media-error-text">
                              {{ 'self_pwa_text.media_validation_message' | translate }}
                            </p>
                            <p *ngIf="isMediaRecomended(formData)" class="media-recomended-text">
                              {{ 'self_pwa_text.media_validation_recomended_message' | translate }}
                            </p>
                          </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
                          <!-- Alert Icon error -->
                          <ion-icon *ngIf="isMediaError(formData)" name="alert-circle-outline" class="error-icon">
                          </ion-icon>
                          <!-- Alert Icon recomended -->
                          <ion-icon *ngIf="isMediaRecomended(formData)" name="alert-circle-outline"
                            class="recomend-icon">
                          </ion-icon>
                          <!-- Badge -->
                          <ion-badge *ngIf="formData?.value?.length" class="badgestyle">
                            {{ formData?.value?.length }}
                          </ion-badge>
                        </div>
                      </ion-card-content>
                    </ng-template>
                  </ion-card-content>
                </ng-container>
                <ng-template #showImage>
                  <ion-card-content fxLayout="row" fxLayoutAlign="space-between center"
                    style="display: flex; align-items: center;">
                    <div fxLayout="row" fxLayoutAlign="start center"
                      style="display: flex; align-items: center; max-width: 100%;">
                      <ion-icon [name]="formData.controlType === 'title' ? 'return-down-forward-outline' : 
                          formData.controlType === 'videos' ? 'videocam-outline' : formData.controlType === 'photos' ? 'image-outline' :
                          'document-outline'" class="captured_icon"></ion-icon>
                      <div fxLayout="column" fxLayoutAlign="center start" style="display: flex;">
                        <h3 style="margin: 0;" class="color-netral-900 font-size-18 l-h-1-3">
                          {{formData.label[_appSetting.selectedLanguage]}}
                          <span *ngIf="getTitleIndicator(formData) === 'mandatory'" class="mandatory-star">*</span>
                          <span *ngIf="getTitleIndicator(formData) === 'recommended'" class="recomended-dot">●</span>
                        </h3>

                        <p style="margin: 0; color: gray;" class="color-netral-500 font-size-14"
                          *ngIf="!isMediaErrorontitle(formData) && ! isMediaRecomendedontitle(formData)">
                          {{
                          formData.controlType === 'title'
                          ? ('self_pwa_text.Tap_to_open_section_text' | translate)
                          : ('self_pwa_text.Tap_to_add_media_text' | translate)
                          }}
                        </p>
                        <p *ngIf="isMediaErrorontitle(formData)" class="media-error-text">
                          {{ 'self_pwa_text.media_validation_message' | translate }}
                        </p>
                        <p *ngIf="isMediaRecomendedontitle(formData)" class="media-recomended-text">
                          {{ 'self_pwa_text.media_validation_recomended_message' | translate }}
                        </p>
                        <p class="media-count" *ngIf="formData.controlType === 'title' && formData.mediaCount > 0">
                          {{ formData.mediaCount }}
                          {{ 'self_pwa_text.media_added' | translate }}
                        </p>
                      </div>
                    </div>
                    <ion-badge
                      *ngIf="(formData.controlType === 'photos' || formData.controlType ==='videos' || formData.controlType ==='files') && formData?.value && formData?.value.length > 0"
                      class="badgestyle" slot="end">{{formData?.value?.length}}</ion-badge>
                  </ion-card-content>
                </ng-template>
              </ion-card>
            </div>
          </div>

          <div *ngIf="selectedTab === 'Questionnaire'" fxLayout="column" class="questionnaire-tab">
            <ng-container *ngIf="updatedFieldsforCustomForm && updatedFieldsforCustomForm[0]?.templateQues.length > 0">
              <app-custom-dynamic-form-builder *ngIf="updatedFieldsforCustomForm && taskDetails"
                (_customFormValues)="submitCustomForm($event)" [customFormJson]="updatedFieldsforCustomForm"
                [taskDetails]="taskDetails" [PageName]="PageName" (formChanged)="onQuesFormChanged()"
                (templateQuesUpdated)="onTemplateQuesUpdated($event)"></app-custom-dynamic-form-builder>
            </ng-container>
          </div>

        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button class="fabbtn" style="
    --background-activated: transparent !important;
    --background-focused: transparent !important;
    width: 48px;
    height: 48px;" [hidden]="isHelpJson == false" (click)="presentHelpModal()">
      <ion-icon name="help-outline"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <input id="fileCapture-control" accept=".pdf,.doc,.docx,.ppt,.pptx" class="display-none" type="file"
    (change)="getFileDetails($event)">

  <div class="action-sheet-controler b-t-r-l-r">
    <ion-select class="Choose_Additional_Features b-t-r-l-r" #additionalFeature interface="action-sheet"
      [(ngModel)]="additionalSelectedControl" (ngModelChange)="getRepeatableControlDetails(additionalSelectedControl)">
      <ion-select-option class="pointer_none action-sheet-design" disabled>{{"native_text.additional_feature_text" |
        translate}}</ion-select-option>
      <ion-select-option *ngFor="let formData of repeatableControlList" [value]="formData">
        {{formData.Originallabel[_appSetting.selectedLanguage]}}
      </ion-select-option>
    </ion-select>
  </div>
  <div class="action-sheet-controler addzoneactionsheet b-t-r-l-r">
    <ion-item>
      <ion-label position="stacked">{{'self_pwa_text.zones_text' | translate}}</ion-label>
      <ion-select class="Choose_Additional_Features b-t-r-l-r" #addZoneSelection interface="popover"
        placeholder="Select Zone" (ionChange)="addNewZone($event)">

        <ion-select-option *ngFor="let item of listForAddNewZone" [value]="item">
          {{ getZoneName(item.templateId) }}
        </ion-select-option>

        <ion-select-option *ngIf="listForAddNewZone?.length === 0" value="">
          {{ "native_text.no_zone_text" | translate }}
        </ion-select-option>
      </ion-select>
    </ion-item>

  </div>

  <div id="newControlName" class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header custome-model p-10 b-b-0 w-100" fxLayout="row" fxLayoutAlign="start center">
          <h5 class="w-100 primary-color regular-fonts-N4">
            {{"native_text.add_edit_name_text" | translate}}</h5>
        </div>
        <div class="modal-body" style="width: 100%;
        padding: 5px;
        border: none !important;">
          <input type="text" matInput [placeholder]="featureNamePlaceholder | translate" id="myText"
            [(ngModel)]="featurename" name="featurename" class="form-control" autofocus />
        </div>
        <div class="modal-footer  custom-footer-model w-100" fxLayout="row" fxLayoutAlign="end center">
          <ion-button class="nobackground regularFonts ion-text-uppercase"
            (click)="closemodal()">{{"common_btn_text.close_btn" | translate}}</ion-button>

          <ion-button class="commonbtn regularFonts ion-text-uppercase" (click)="AddNewControls()">
            {{"common_text.add_text" | translate}}
          </ion-button>
        </div>
      </div>
    </div>
  </div>
</ion-content>
<ion-footer class="white-background ion-text-center footer-style">
  <div fxLayout="row" fxLayoutAlign="space-evenly none" class="m-l-5">
    <div fxFlex="96">
      <ion-button expand="block" data-testid="confirm-btn"
        class="t-c commonbtn show-fulltext h-48 font-size-16 inter-medium letter-spacing-normal"
        (click)="gotoPhotoSummaryPage()">
        {{
        "common_text.preview_and_inspection_text" | translate }}
      </ion-button>
    </div>
    <!-- <div fxFlex="47">
      <ion-button class="nobackground show-fulltext h-48 font-size-16 t-c inter-medium letter-spacing-normal"
        expand="block" fill="outline" (click)="saveandsubmitlater()">
        {{
        "common_btn_text.save_finish_btn" | translate }}
      </ion-button>
    </div>
    <div fxFlex="47">
      <ion-button expand="block" data-testid="confirm-btn"
        class="t-c commonbtn show-fulltext h-48 font-size-16 inter-medium letter-spacing-normal"
        (click)="gotoPhotoSummaryPage()">
        {{
        "common_text.preview_and_inspection_text" | translate }}
      </ion-button>
    </div> -->
  </div>
</ion-footer>